<template lang="pug"></template>

<script>
export default {
    name: 'BotaoListaArmazem',
    componentOptions: {
        title: 'Armazém',
        actions: [
            [
                {
                    name: 'Lista Instalacoes',
                    iconClass: 'lyra-icon lyra-armazem',
                    showView: false,
                    action: 'abrirListaArmazem',
                    route: 'ListaArmazem'
                }
            ]
        ]
    },

    methods: {
        abrirListaArmazem() {
            if (this.$route.name !== 'ListaArmazem') {
                this.$router.push({ name: 'ListaArmazem' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
